/**
 * This module provides a reliable mechanism to get hold of the jQuery facade global.
 *
 * This is NOT as simple as looking for objects in the global scope.
 *
 * e.g. In Confluence, it's possible for the browser to fail to load jQuery from
 * Google's CDN but then our (Atlassian) JS will initialize $.
 * For more details, see: https://jdog.jira-dev.com/browse/PGI-695
 *
 * This modules assumes that jQuery is expected to be present before the
 * experiment's JS is loaded. If it finds jQuery, it will return it, otherwise it will return null.
 *
 * This should work across all products. (JIRA, Confluence, HipChat, WAC).
 */
const Promise = require('yaku');

/**
 * Verify that the specified object is the jQuery facade.
 *
 * If it is, return the object, otherwise return null.
 */
function verify(object) {
  let jQuery;
  try {
    jQuery = typeof object.fn.jquery === 'string' ? object : null;
  } catch (e) {
    jQuery = null;
  }
  return jQuery;
}

/**
 * Look for the jQuery facade object.
 *
 * If we find it, return it. Otherwise returns null;
 *
 * We won't use Optimizely's incomplete version of jQuery
 * by using window.$ instead of $
 *
 * @returns {jQuery}
 */
function findjQuery() {
  let jQuery = null;
  try {
    jQuery = jQuery || verify(window.require('jquery'));
  } catch (e) {
  }
  try {
    jQuery = jQuery || verify(AJS.$);
  } catch (e) {
  }
  try {
    jQuery = jQuery || verify(window.$);
  } catch (e) {
  }
  try {
    jQuery = jQuery || verify(window.jQuery);
  } catch (e) {
  }
  return jQuery;
}

/**
 * Returns a promise which is resolved with jQuery,
 * if it can be found in time.
 *
 * Otherwise the promise is rejected.
 * @returns {Promise}
 */
export default function() {
  const TIME_LIMIT_MS = 20 * 1000;
  const OFTEN_MS = 10;
  let expiry = new Date().valueOf() + TIME_LIMIT_MS;
  let intervalId = null;
  return new Promise((resolve, reject) => {
    intervalId = setInterval(() => {
      const now = new Date().valueOf();
      if (now > expiry) {
        reject(new Error('Could not find jQuery in ' + TIME_LIMIT_MS + ' ms'));
      } else {
        let jQuery = findjQuery();
        if (jQuery) {
          clearInterval(intervalId);
          intervalId = null;
          resolve(jQuery);
        }
      }
    }, OFTEN_MS);
  });
}


// WEBPACK FOOTER //
// ./~/@atlassiansox/experiment-common-core/lib/when-jquery.js